import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

const COMPANY = 'COMPANY'

const serviceName = 'ProspectingOpportunitiesService'
const host = servicesConfig.Opportunities as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const responseBody = (res: AxiosResponse) => res.data

class ProspectingOpportunitiesService {
  static getPipelines = async (locationId: string) => {
    try {
      if (!locationId || typeof locationId !== 'string') {
        return []
      }
      const response = await request().get(`/pipelines?locationId=${locationId}`).then(responseBody)

      const result = response.pipelines?.map((pipeline: { id: any; name: any; stages: any[] }) => ({
        id: pipeline.id,
        name: pipeline.name,
        stages:
          pipeline.stages?.map(stage => ({
            id: stage.id,
            name: stage.name,
          })) || [],
      }))

      return result
    } catch (error) {
      return []
    }
  }
}

export default ProspectingOpportunitiesService
